import React, { Component } from "react";
import { connect } from "react-redux";
import Drawer from "@material-ui/core/Drawer";
import List from "./List";

import CloseIcon from "@material-ui/icons/Close";
import Divider from "@material-ui/core/Divider";

import IconButton from "@material-ui/core/IconButton";

import { animateScroll as scroll, scroller } from "react-scroll";
import FilterListIcon from "@material-ui/icons/FilterList";
import ProductFilter from "../ProductDetails/ProductFilter/ProductFilter";
import { Chip } from "@material-ui/core";
import {
  clearPriceRange,
  clearSortBy,
  deleteFilter,
  setFilter,
  setSortBy,
} from "../../store/actions/productFilter";
import { setProduct } from "../../store/actions";

export class Index extends Component {
  state = {
    drawerState: false,
    SelectedCategory: null,
    filterDrawerOpen: false,
  };

  toggleDrawer = (open, id) => {
    window.scrollBy(0, 5);
    window.scrollBy(0, -5);

    this.setState({ drawerState: open, SelectedCategory: id });
  };

  componentDidMount() {
    window.addEventListener("resize", this.reportWindowSize);
    if (!this.state.isMobile) {
      if (window.outerWidth < 768) this.setState({ isMobile: true });
      else this.setState({ isMobile: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.reportWindowSize);
  }

  reportWindowSize = () => {
    if (window.outerWidth < 768) this.setState({ isMobile: true });
    else this.setState({ isMobile: false });
  };
  handleFilterDrawerToggle = () => {
    this.setState({ filterDrawerOpen: !this.state.filterDrawerOpen });
  };

  state = {
    isMobile: undefined,
  };

  render() {
    const { selectedCategory } = this.props;
    const language = this.props.language;

    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    let categories = [];
    let categories_Navigate = [];
    let border =
      language === "english"
        ? { borderLeft: `4px solid ${themeColor}` }
        : { borderRight: `4px solid ${themeColor}` };
    this.props.categories.forEach((category) => {
      if (category.products.length) {
        categories.push(
          <List
            key={"List_Category " + category.name + category.id}
            category={category}
            isMobile={this.state.isMobile}
            onClick={(id) => this.toggleDrawer(true, id)}
          />
        );
        categories_Navigate.push(
          <div key={"Navigate_Category " + category.name + category.id}>
            <div
              onClick={(e) => {
                scroller.scrollTo("navigate" + category.id, {
                  duration: 0,
                  delay: 0,
                  offset: this.state.isMobile ? -110 : -54,
                  smooth: "easeInOutQuart",
                });
                this.toggleDrawer(false);
              }}
              style={category.id === this.state.SelectedCategory ? border : {}}
              className={`d-flex flex-row justify-content-between py-3 ${
                language === "arabic" ? "flex-row-reverse" : ""
              }  `}
            >
              <p class="my-auto mx-3 ">{`${
                language === "english" ? category.name : category.ar_name
              }`}</p>
              <p
                class=" my-auto"
                style={{
                  marginRight: language === "english" ? "1rem" : 0,
                  marginLeft: language === "arabic" ? "1.8rem" : 0,
                }}
              >
                {category.products.length}
              </p>
            </div>
            <hr className="half-line" />
          </div>
        );
      }
    });

    return (
      <>
        <div className="mb-5 w-100 ">
          <Drawer
            className="h-100"
            anchor="top"
            PaperProps={{
              className: this.props.language === "arabic" ? "ml-auto" : "",
            }}
            open={this.state.drawerState}
            onClose={() => this.toggleDrawer(false)}
          >
            <div
              style={{
                backgroundColor: "white",
                overflowX: "hidden",
              }}
            >
              <div
                className={`  d-flex flex-row justify-content-between ${
                  language === "arabic" ? "flex-row-reverse" : ""
                }  `}
                onClick={() => this.toggleDrawer(false)}
              >
                <p class=" font-weight-bold my-auto mx-3 ">{`${
                  language === "english" ? "Menu List" : "القائمة"
                }`}</p>
                <div class="mx-2">
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={() => this.toggleDrawer(false)}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>

              <Divider />

              {categories_Navigate}
            </div>
          </Drawer>
          {categories}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.store.store.categories,
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    secondLoading: state.store.secondLoading,
    filtersSelected: state.productFilter.filtersSelected,
    sortBy: state.productFilter.sortBy,
    priceRange: state.productFilter.priceRange.range,
    categoriesFilter: state.productFilter.selectedCategories,
    selectedCategory: state.selectedCategoryHeader.selectedCategory,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    deleteFilter: (value) => dispatch(deleteFilter(value)),
    clearSortBy: () => dispatch(clearSortBy()),
    clearPriceRange: () => dispatch(clearPriceRange()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
